import React, { useState, useEffect, useRef } from 'react';

const IntroSection = ({ t }) => {
  const introRef = useRef(null);
  const [introVisible, setIntroVisible] = useState(false);

  useEffect(() => {
    const currentRef = introRef.current;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIntroVisible(true);
          }
        });
      },
      { threshold: 0.15 }
    );
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, []);

  // Split intro text into paragraphs
  const paragraphs = t.introDesc ? t.introDesc.split('\n') : [];

  return (
    <section id="intro" className="intro-text-section" aria-labelledby="intro-heading">
      <h2 id="intro-heading" className="visually-hidden">Introduction</h2>
      <div ref={introRef} className={`intro-text-content ${introVisible ? 'visible' : ''}`}>
        {paragraphs.map((paragraph, i) => (
          <p 
            key={`intro-paragraph-${i}`} 
            className={i === 0 ? 'intro-highlight' : 'intro-body'}
          >
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};

export default React.memo(IntroSection);
